import React, { useState, useRef, useEffect } from "react";
import { useDrag } from "react-dnd";
import Aside3 from "../Aside3";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TbHeading } from "react-icons/tb";
import { TbHeadingOff } from "react-icons/tb";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { FiFilter } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  setCommonFilters,
  setWorkbookProperty,
  updateLevel2Properties,
  setLevel2Properties,
} from "../WorkbookSlice";
import { Dropdown } from "flowbite-react";
import DashboardFilterModal from "./DashboardFilterModal";
import CordinateMap from "../../../components/VizComponents/MapWithCordinate/CordinateMap";

const ResizableHandle = ({ onMouseDown }) => (
  <div
    className="border-r-2 border-b-2 border-gray-950 z-50"
    onMouseDown={onMouseDown}
    style={{
      width: "8px",
      height: "8px",
      position: "absolute",
      right: "0",
      bottom: "0",
      cursor: "se-resize",
    }}
  />
);
const snapToGrid = (value, gridSize) => {
  const convertedPixels = Math.max(0, value * gridSize);
  return convertedPixels;
};
const convertToGridUnits = (value, gridSize, gridColumns, xLocation) => {
  let gridUnits = Math.max(1, Math.round(value / gridSize), 0);

  if (gridColumns) {
    if (gridColumns < gridUnits + xLocation) {
      gridUnits = gridColumns - xLocation;
    }
    // gridUnits = Math.min(gridColumns - width, gridUnits);
  }

  return gridUnits;
};

const DraggableItem = ({
  Sheetid,
  x,
  y,
  width,
  height,
  SheetName,
  Title,
  sheetid,
  quillContent,
  updateItemSize,
  onDrop,
  handleRemoveItem,
  handleTitle,
  gridSize,
  gridColumns,
  dashboardSheetID,
  isHeaderVisible,
  setHeaderVisibilityArray,
  setIsQuillEditing,
  item,
  items,
  isAnimataionOff,
  isParagraph,
}) => {
  // console.log(item.Sheetid);
  console.log(item.SheetVizType);
  // console.log(item.dataSourceID);

  // console.log(quillContent);

  const itemRef = useRef(null);
  const buttonRef = useRef(null);
  const mainHeight = itemRef.current && itemRef.current.offsetHeight;
  const buttonHeight = buttonRef.current && buttonRef.current.offsetHeight;
  const headerHeight = `${(buttonHeight / mainHeight) * 100}%`;
  const chartHeight = `${((mainHeight - buttonHeight) / mainHeight) * 100}%`;

  const dispatch = useDispatch();
  const [isResizing, setIsResizing] = useState(false);
  const [dashboardFilterModal, setDashboardFilterModal] = useState(false);
  const [hoveredSheetid, setHoveredSheetid] = useState(null);
  const SHEETID = Sheetid ? Sheetid : Sheetid ? Sheetid : Sheetid;

  const reduxSheetName = useSelector((state) =>
    getL1SheetProperty(state, SHEETID, "SheetName")
  );
  const ObjectArray =
    useSelector((state) => {
      return getL2SheetProperty(state, Sheetid, "query", "filters");
    }) || [];

  const filterItem = ObjectArray.find((filter) => filter.Sheetid === Sheetid);
  // console.log(quillContent);
  // console.log(reduxSheetName);

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "ITEM",
      item: { Sheetid, x, y, width, height },
      end: (item, monitor) => {
        if (monitor.didDrop() && onDrop) {
          onDrop(item);
        }
      },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [Sheetid, x, y, width, height, onDrop]
  );

  const startResizing = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
  };

  const handleMouseMove = (e) => {
    if (isResizing) {
      const itemRect = itemRef.current.getBoundingClientRect();
      const newWidth = convertToGridUnits(
        e.clientX - itemRect.left,
        gridSize,
        gridColumns,
        x
      );
      const newHeight = convertToGridUnits(e.clientY - itemRect.top, gridSize);

      updateItemSize(Sheetid, newWidth, newHeight, quillContent);
    }
  };

  const stopResizing = () => {
    setIsResizing(false);
  };

  useEffect(() => {
    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", stopResizing);
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, handleMouseMove]);

  const style = {
    left: snapToGrid(x, gridSize),
    top: snapToGrid(y, gridSize),
    width: snapToGrid(width, gridSize),
    height: snapToGrid(height, gridSize),
    cursor: isDragging ? "move" : "default",
    opacity: isDragging ? 0.7 : 1,
    transition: "left 0.2s, top 0.2s, width 0.2s, height 0.2s",
    // overflow: "hidden",
    zIndex: isDragging ? 1000 : "auto",
  };

  function updateObjectArray(ObjectArray, dashboardIdToRemove) {
    return ObjectArray.map((obj) => {
      // Remove the dashboardID from the dashboardIDs array
      const updatedDashboardIDs = obj.dashboardIDs.filter(
        (id) => id !== dashboardIdToRemove
      );

      // Return the updated object with the updated dashboardIDs
      return {
        ...obj,
        dashboardIDs: updatedDashboardIDs,
      };
    });
  }

  const handleUpdateFilterWithDashboardId = ({
    nanoId,
    dashIDs,
    removeAllSheetFilters,
  }) => {
    console.log(nanoId);

    const requiredObjectIndex = ObjectArray.findIndex(
      (item) => item.nanoId === nanoId
    );
    if (removeAllSheetFilters) {
      console.log("remove all dashboard filters");
      const updatedObjectArray = updateObjectArray(ObjectArray, dashIDs);
      dispatch(
        updateLevel2Properties({
          reduxKey: "filters",
          Sheetid: Sheetid,
          parentKey: "query",
          value: updatedObjectArray,
          itemInArray: false,
          index: requiredObjectIndex,
        })
      );
    } else {
      // Find the required object by nanoId
      const requiredObjectIndex = ObjectArray.findIndex(
        (item) => item.nanoId === nanoId
      );
      console.log(ObjectArray);
      console.log(requiredObjectIndex);

      // Check if the object exists
      if (requiredObjectIndex === -1) {
        console.error("Object not found for the given nanoId");
        return;
      }

      const requiredObject = ObjectArray[requiredObjectIndex];

      // Ensure dashboardIDs is an array (convert it to an array if not)
      const dashboardIDsArray = Array.isArray(requiredObject.dashboardIDs)
        ? requiredObject.dashboardIDs
        : [];

      // Check if dashIDs already exists in dashboardIDsArray
      const updatedDashboardIDs = dashboardIDsArray.includes(dashIDs)
        ? dashboardIDsArray.filter((id) => {
            console.log(id);

            return id !== dashIDs;
          }) // Remove dashIDs if it exists
        : [...dashboardIDsArray, dashIDs]; // Add dashIDs if it doesn't exist

      console.log(updatedDashboardIDs);
      dispatch(
        setCommonFilters({
          value: { ...requiredObject, dashboardIDs: updatedDashboardIDs },
          operation: "UPDATE",
          Sheetid: Sheetid,
        })
      );
    }
  };

  const handleDraggableItemHover = (SHEETID) => {
    setHoveredSheetid(SHEETID);
  };

  const handleHeaderVisibilityArray = (SHEETID) => {
    setHeaderVisibilityArray((prevArray) => {
      if (Array.isArray(prevArray) && prevArray.includes(SHEETID)) {
        return prevArray.filter((id) => id !== SHEETID); // Remove SHEETID
      } else {
        return [...prevArray, SHEETID]; // Add SHEETID
      }
    });
  };

  const editChart = (id) => {
    console.log(id);
    if (id) {
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key: "selectedSheetId",
          value: id,
        })
      );
    }
  };
  useEffect(() => {
    if (item.Sheetid) {
      dispatch(
        setLevel2Properties({
          reduxKey: "dashboardBoxSize",
          Sheetid: item.Sheetid,
          parentKey: "customization",
          value: {
            width: style.width,
            height: style.height,
          },
          itemInArray: false,
        })
      );
    }
  }, [style.width, style.height]);
  return (
    <>
      <main
        ref={(node) => {
          drag(node);
          itemRef.current = node;
        }}
        style={style}
        className={`w-full h-full flex flex-col items-center justify-start border border-gray-200 rounded bg-white absolute overflow-hidden `}
        onMouseEnter={() => {
          handleDraggableItemHover(SHEETID);
        }}
        onMouseLeave={() => {
          handleDraggableItemHover(null);
        }}
      >
        {/* header content */}
        {hoveredSheetid === SHEETID || isHeaderVisible ? (
          <header
            className={`w-full ${
              isHeaderVisible ? "" : "absolute top-0 right-0 z-40"
            }  flex items-start group justify-between  bg-white bg-opacity-90 px-2 py-1`}
            style={{ height: isHeaderVisible ? headerHeight : "" }}
          >
            {isHeaderVisible && (
              <button
                ref={buttonRef}
                className="font-[500] text-lg flex items-start text-left justify-start w-[96.5%] max-w-[96.5%] min-w-[5rem] pl-1 break-words whitespace-normal"
              >
                {reduxSheetName}
              </button>
            )}
            <button
              className={`${
                !isHeaderVisible ? "w-full" : "w-[3.5%]"
              }  flex items-center justify-end relative top-0 right-0 break-words whitespace-normal mt-1`}
            >
              <Dropdown
                label={
                  <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                }
                arrowIcon={false}
                className="w-28 h-auto max-h-28 z-50"
                placement="right-start"
              >
                {isParagraph ? (
                  <Dropdown.Item
                    className="flex items-center text-left justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                    onClick={() => setIsQuillEditing(SHEETID)}
                  >
                    Edit
                    <FaRegEdit />
                  </Dropdown.Item>
                ) : (
                  <>
                    <Dropdown.Item
                      className="flex items-center text-left justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                      onClick={() => handleHeaderVisibilityArray(SHEETID)}
                    >
                      Heading
                      {isHeaderVisible ? <TbHeading /> : <TbHeadingOff />}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="flex items-center text-left justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                      onClick={() => editChart(!isParagraph ? SHEETID : null)}
                    >
                      Edit Chart
                      <FaRegEdit />
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="flex items-center text-left justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                      onClick={() =>
                        setDashboardFilterModal(!dashboardFilterModal)
                      }
                    >
                      Filters
                      <FiFilter />
                    </Dropdown.Item>
                  </>
                )}
                <Dropdown.Item
                  className="flex items-center text-left justify-start w-full text-[14px] hover:text-teal-600 pl-2 py-[2px] gap-1 truncate"
                  onClick={() => {
                    handleRemoveItem(Sheetid);
                    if (filterItem) {
                      handleUpdateFilterWithDashboardId({
                        nanoId: filterItem.nanoId,
                        dashIDs: dashboardSheetID,
                        removeAllSheetFilters: true,
                      });
                    }
                  }}
                >
                  Delete
                  <RiDeleteBin6Line />
                </Dropdown.Item>
              </Dropdown>
            </button>
          </header>
        ) : null}

        {/* main content */}
        <div
          style={{
            height: isHeaderVisible ? chartHeight : "100%",
            width: "100%",
          }}
        >
          {isParagraph ? (
            <div
              dangerouslySetInnerHTML={{ __html: quillContent }}
              className="w-full h-full p-[2px] overflow-auto"
            ></div>
          ) : null}
          {(Sheetid || Sheetid) &&
          SheetName &&
          !["cordinatemap"].includes(item.SheetVizType) ? (
            <Aside3
              currentSheet={{
                Sheetid: SHEETID || Sheetid,
                SheetName: SheetName,
              }}
              workbookType={"draft"}
              publishevent={false}
              isSheetInDashboard={true}
              dashboardAnimation={isAnimataionOff}
              widthHeightObject={{ width: style.width, height: style.height }}
              isQueryRunning={false}
            />
          ) : null}
          {item.SheetVizType === "cordinatemap" ? (
            <CordinateMap
              Sheetid={SHEETID || Sheetid}
              vizType={item.SheetVizType}
              workbookType={"draft"}
              dataSourceID={item.dataSourceID}
              isSheetInDashboard={true}
              widthHeightObject={{ width: style.width, height: style.height }}
            />
          ) : null}
        </div>

        <ResizableHandle onMouseDown={startResizing} />
      </main>

      {dashboardFilterModal ? (
        <DashboardFilterModal
          closeModal={() => setDashboardFilterModal(false)}
          ObjectArray={ObjectArray}
          handleUpdateFilterWithDashboardId={handleUpdateFilterWithDashboardId}
          dashboardSheetID={dashboardSheetID}
        />
      ) : null}
    </>
  );
};

export default DraggableItem;
